//--------------------------------------------------
// imported classes
//--------------------------------------------------
const BaseMediator = require('@/tbs/controller/BaseMediator')
const ClassFunc = require('@/tbs/util/ClassFunc')
const GameEvent = require('@/tbs/model/vo/GameEvent')
const DataConvertor = require('@/tbs/core/DataConvertor')
const ObjectFunc = require('@/tbs/util/ObjectFunc')

/**
 * The MatchMediator class maintains the business logic
 * for the organization.
 */
const tbs_controller_GameEventMediator = function() {
    //--------------------------------------------------
    // super method for the base class
    //--------------------------------------------------
    ClassFunc.super(this, BaseMediator, arguments)
    // console.log('tbs_controller_GameEventMediator constructor')
}

//--------------------------------------------------
// prototype
//--------------------------------------------------
tbs_controller_GameEventMediator.prototype = {
    //--------------------------------------------------
    // api method
    //--------------------------------------------------
    handleCreationComplete: function() {
        // console.log('handleCreationComplete')
        if (this._bridge.isCreate() || this._bridge.isEdit()) {
            this.fetchTeamPlayers()
        }
        /*if (!this._bridge.isCreate()) {
            this.creationComplete()
        }*/
        this.target().game = ObjectFunc.mergeObject(ObjectFunc.cloneObject(this._bridge.getRouteQuery()), ObjectFunc.cloneObject(this._bridge.getRouteParam()))
    },
    handleUpdateService: function() {
        this._bridge.back()
    },
    fetchTeamPlayersComplete: function() {
        if (this._bridge.isCreate()) {
            // preset the first options as the selected one
            const gameEvent = new GameEvent
            this.target().event.teamId = this.target().game.homeTeamId
            this.target().event.eventType = gameEvent.defaultEventType
            this.target().event.eventSpecType = gameEvent.defaultEventSpecType
        }
        else if (this._bridge.isEdit()) {
            this.creationComplete()
        }
    },
    fetchTeamPlayers: function() {
        console.log('fetchTeamPlayers')
        const self = this
        const convertor = new GameEvent
        const type = 'manage'
        const source = convertor.view[type]
        const service = 'manageTeamPlayerList'
        const parameters = [
            { teamId: this._bridge.getRouteQuery('homeTeamId'), gameId: this._bridge.getRouteParam('gameId'), matchId: this._bridge.getRouteQuery('matchGroupId') },
            { teamId: this._bridge.getRouteQuery('awayTeamId'), gameId: this._bridge.getRouteParam('gameId'), matchId: this._bridge.getRouteQuery('matchGroupId') }
        ]
        console.log('fetchTeamPlayers@parameters', parameters, this._bridge.getRouteParam())
        self._bridge.addResourceListener(service, function(e) {
            self._bridge.removeResourceListener(service, e.handler)
            console.log('fetchTeamPlayers.data', e.data)
            let viewData = {}
            let dataSets = e.data.dataSets
            for (let i = 0; i < dataSets.length; i++) {
                let dataSet = dataSets[i]
                if (dataSet.result) {
                    let item = convertor.view[type][i]
                    console.log('dataSet', dataSet)
                    const transformedData = DataConvertor.doTransform(convertor, item.basePath, item.rule, dataSet.payload, type)
                    if (viewData[item.name]) {
                        ObjectFunc.mergeObject(viewData[item.name], transformedData)
                    }
                    else {
                        viewData[item.name] = transformedData
                    }
                }
            }
            // const wrapper = DataConvertor.wrapper(convertor)
            const wrapper = 'playerList'
            console.log('@wrapper-viewData', wrapper, viewData)
            // console.log('@target', self.target(), wrapper)
            if (self.handleViewDataWrap(viewData)) {
                if (wrapper) {
                    self.target()[wrapper] = viewData
                }
                else {
                    for (let p in viewData) {
                        self.target()[p] = viewData[p]
                    }
                }
            }
            self.fetchTeamPlayersComplete(e)
        })
        self._bridge.callResourceInstance(service, {
            services: ObjectFunc.extractProperties(source, ['baseUrl', 'apiPrefix', 'apiSuffix', 'service']),
            method: 'GET',
            parameters: parameters
        }, true)
    }
}

//--------------------------------------------------
// extends the BaseMediator
//--------------------------------------------------
ClassFunc.extend(tbs_controller_GameEventMediator, BaseMediator);

module.exports = tbs_controller_GameEventMediator